const state = {
  entries: []
}

const getters = {
  lastEntry: state => {
    if (state.entries.length > 0) {
      return state.entries[state.entries.length - 1]
    } else {
      return undefined
    }
  }
}

const mutations = {
  pushEntry (state, route) {
    if (state.entries.length > 0) {
      const lastEntry = state.entries[state.entries.length - 1]

      if (lastEntry.meta.block && route.meta.block) {
        if (lastEntry.meta.block !== route.meta.block) {
          state.entries.push(route)
        }
      } else if (lastEntry.name !== route.name) {
        state.entries.push(route)
      }
    } else {
      state.entries.push(route)
    }
  },
  popEntry (state) {
    state.entries.pop()
  }
}

const actions = {

}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
